import React, { Component } from "react";

import { Grid, Row, Col } from "react-bootstrap";
import { Query } from "react-apollo";
import gql from "graphql-tag";
import { ApolloClient } from 'apollo-client';
import { InMemoryCache } from 'apollo-cache-inmemory';

import HttpLinkServices from "../../services/HttpLinkServices";
import SearchNotFound from "../../components/SearchNotFound";

import Config from "../../config/config";
import banner_default from '../../assets/img/Cursos_Presenciais-05.jpg';


import { addToDataLayerGTM } from "../../utils/addToDataLayerGTM";
import ErrorModal from "../../components/Modal/ErrorModal";

const months = ['JAN', 'FEV', 'MAR', 'ABR', 'MAI', 'JUN', 'JUL', 'AGO', 'SET', 'OUT', 'NOV', 'DEZ']

const lms_client = new ApolloClient({
  link: HttpLinkServices.lms,
  cache: new InMemoryCache(),
});

const GET_CURSES = gql`{
  classroom_collections(order: "DESC", orderby: "id"){
    classroom{
      id,datetime_start_format, datetime_end_format, course{thumbnail,title, description}
    }
  }
}
`;

class PresentialList extends Component {

  createLegend(json) {
    var legend = [];
    for (var i = 0; i < json["names"].length; i++) {
      var type = "fa fa-circle text-" + json["types"][i];
      legend.push(<i className={type} key={i} />);
      legend.push(" ");
      legend.push(json["names"][i]);
    }
    return legend;
  }

  minutes_with_leading_zeros(dt) {
    return (dt.getMinutes() < 10 ? '0' : '') + dt.getMinutes();
  }

  componentDidMount() {
    // Google Tag Manager
    const dataLayer = {
      'event': 'step_change',
      'etapa': '/cursos/presenciais/',
    }
    addToDataLayerGTM(dataLayer);
  }

  handleRegistration(title){
    // Google Tag Manager
    const dataLayer = {
      'event': 'step_change',
      'etapa': `/cursos/presenciais/matricular/${title}`,
    }
    addToDataLayerGTM(dataLayer);
  }

  render() {

    return (
      <div>
        <Query
          client={lms_client}
          query={GET_CURSES}
        >
        {({ loading, error, data }) => {
          if (loading) return <div>Carregando...</div>;
          if (error){
            // Google Tag Manager
            addToDataLayerGTM({
              'event' : 'erro',
              'etapa' : 'erro ao buscar categorias'
            });
            return <ErrorModal />;
          };

            return (
              <img className="banner_content" src={data.category && data.category.banner ? Config.baseUrl + "/dam/assets/" + data.category.banner : banner_default} />
            );
          }}
        </Query>
        <div className="content">
          <div className="container presential-course">

            <Grid fluid>
              <Row>

                <Query
                  client={lms_client}
                  query={GET_CURSES}
                >
                  {({ loading, error, data }) => {
                    if (loading) return <div>Carregando...</div>;
                    if (error) {
                      // Google Tag Manager
                      addToDataLayerGTM({
                        'event' : 'erro',
                        'etapa' : 'erro ao buscar os cursos'
                      });

                      return <ErrorModal />;
                    };

                    if (!data.classroom_collections || !data.classroom_collections.classroom.length) {
                      return (<SearchNotFound
                        onClick={() => window.location.href = "/#/home"}
                        buttonMessage="Voltar a página inicial"
                      />)
                    }

                    return data.classroom_collections.classroom.map((item) => (
                      <Row className="border-bottom">
                        <Col lg={1} sm={1} className="col">
                          <div className="live_item_calendar">
                            {months[new Date(item.datetime_start_format).getMonth()]}
                            <span>{new Date(item.datetime_start_format).getDate()}</span>
                          </div>
                        </Col>
                        <Col lg={2} sm={2} className="col">
                          {new Date(item.datetime_start_format).toLocaleDateString("pt-BR")}<br />
                          {new Date(item.datetime_start_format).getHours()}:{this.minutes_with_leading_zeros(new Date(item.datetime_start_format))}
                          <br /><br />
                          Fim: {new Date(item.datetime_end_format).toLocaleDateString("pt-BR")}<br />
                          {new Date(item.datetime_end_format).getHours()}:{this.minutes_with_leading_zeros(new Date(item.datetime_end_format))}
                        </Col>
                        <Col lg={7} sm={7} className="col">
                          <p><strong>{item.course.title}</strong></p>
                          <p>{item.course.description}</p>
                        </Col>
                        <Col lg={2} sm={2} className="col">
                          <a
                            data-gtm-type="click"
                            data-gtm-clicktype="button"
                            data-gtm-name={"matricular_" + item.course.title}
                            className="btn btn-info"
                            href={"/#/curso-presencial/" + item.id}
                            onClick={() => this.handleRegistration(item.course.title)}
                          >
                            Matricular
                          </a>
                        </Col>
                      </Row>

                    ));
                  }}
                </Query>

              </Row>
            </Grid>
          </div>
        </div>
      </div>
    );
  }
}

export default PresentialList;



// WEBPACK FOOTER //
// ./src/views/Courses/PresentialList.jsx